/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { permitCategories } from '../../utils/utilsNew';
import {
    PERMIT_CATEGORY_HIKING,
    PERMIT_CATEGORY_WILDERNESS,
    SAN_JUAN_ID,
    KING_RANGE_ID,
} from '../../constants';
import PreferenceDetailItem from './PreferenceDetailItem';

export default class PreferenceDetailList extends React.Component {
    static defaultProps = {
        choices: [],
        dates: [],
        nights: 0,
        preferences: {},
        disablePreferences: false,
    };

    static propTypes = {
        choices: PropTypes.arrayOf(PropTypes.shape({})),
        dates: PropTypes.arrayOf(PropTypes.any),
        nights: PropTypes.number,
        preferences: PropTypes.objectOf(PropTypes.string),
        handlePreferenceChange: PropTypes.func,
        disablePreferences: PropTypes.bool,
        permitCategory: PropTypes.number,
        permitId: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.handleOptionSelection = this.handleOptionSelection.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.nights !== this.props.nights) {
            this.cleanEntries(this.props);
        }
    }

    cleanEntries(nextProps) {
        const preferences = this.props.preferences;
        const dates = nextProps.dates;

        if (isEmpty(dates)) {
            this.props.handlePreferenceChange({});
        } else {
            const newPreferences = {};
            dates.forEach((date) => {
                newPreferences[date] = preferences[date];
            });
            this.props.handlePreferenceChange(newPreferences);
        }
    }

    handleOptionSelection(date, value) {
        const { preferences } = this.props;
        preferences[date] = value;

        this.props.handlePreferenceChange(preferences);
    }

    renderItems() {
        const { preferences, dates, permitId } = this.props;
        return dates.map((date, i) => {
            let disablePrefs = this.props.disablePreferences;
            if (permitId === SAN_JUAN_ID && dates.length > 2 && i < dates.length - 2) {
                disablePrefs = true;
            }
            return (
                <PreferenceDetailItem
                    key={date}
                    dateIndex={i}
                    date={date}
                    choice={preferences[date]}
                    options={this.props.choices}
                    disablePreferences={disablePrefs}
                    disableSecondPreference={permitId === KING_RANGE_ID}
                    handleOptionSelection={this.handleOptionSelection}
                />
            );
        });
    }

    render() {
        if (isEmpty(this.props.dates)) {
            return null;
        }

        let header = 'Campsite Requests';
        if (
            this.props.permitCategory &&
            (this.props.permitCategory === permitCategories.get(PERMIT_CATEGORY_HIKING) ||
                this.props.permitCategory ===
                    permitCategories.get(PERMIT_CATEGORY_WILDERNESS))
        ) {
            header = 'Trip Itinerary';
        }
        return (
            <div className="per-campsite-request-form per-section-group">
                <div className="rec-order-detail-subsection-title">{header}</div>
                <p>
                    Changes to your campsite request less than 30 days before your trip
                    may not be reflected in your permit.
                </p>
                <div className="per-preference-list">{this.renderItems()}</div>
            </div>
        );
    }
}
